import * as analytics from 'utilities/analytics';
import * as logger from 'utilities/loggerx';

const trackFromVideo = (video, eventName) => {
  if (!video || !eventName) {
    logger.warning(new Error('Video and eventName must be provided to track'));

    return;
  }

  const {
    id,
    current_user_is_owner,
    owner_id,
    video_properties: { recordingClient, client, sdkPartnerId },
  } = video;

  analytics.track(eventName, {
    videoId: id,
    client: recordingClient || client,
    sdkPartnerId,
    currentUserIsOwner: current_user_is_owner,
    videoOwnerId: owner_id,
  });
};

export { trackFromVideo };
